import { render, staticRenderFns } from "./QuantityInStock.vue?vue&type=template&id=4d4a2a44&"
import script from "./QuantityInStock.vue?vue&type=script&lang=js&"
export * from "./QuantityInStock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports